module.exports = __webpack_public_path__ + "img/reg-done.90851c99.png";